import { PetNamesPage } from '@web/components/pet-names-page';
import { PetNamesScreenProps } from 'shared/screens/pet-names';
import { withServerProps } from '@web/library/with-server-props';

export default function DogNames(props: PetNamesScreenProps) {
  return <PetNamesPage {...props} animal={'dog'} />;
}

export const getServerSideProps = withServerProps();
